


















































import Vue from 'vue';
import { AxiosError, AxiosResponse } from 'axios';

const GChart = require('vue-google-charts');

import UserAPI from '@/services/UserAPI';

import User from '@/types/User';
import { UserStatus } from '@/types/UserStatus';

import LanguageSelectorTab from '@/components/LanguageSelectorTab.vue';
import Loader from '@/components/Loader.vue';
import Pagination from '@/components/Pagination.vue';

export default Vue.extend({
    name: 'UserList',

    components: {
        LanguageSelectorTab,
        Loader,
        Pagination
    },

    data() {
        return {
            users: new Array<User>(),
            error: {
                loading: ''
            },
            status: '',
            isLoading: false,
            isSaving: false,
            validated: UserStatus.Validated,
            chartData: [],
            chartOptions: {
                chart: {
                    title: 'Antal användare',
                    subtitle: 'Per dag',
                }
            },
            verifiedUsersCount: 0,
            totalUsersCount: 0,
            page: 1
        };
    },

    created() {
        this.loadUsers(1);
    },

    methods: {

        loadUsers(page: number): void {
            const handleResponse = (response: AxiosResponse) => {
                    this.users = response.data;
                    this.chartData = this.numberUsers(this.users);
                    this.verifiedUsersCount = response.headers['x-verified-count'];
                    this.totalUsersCount = response.headers['x-total-count'];
                };

            const handleError = (error: AxiosError) => {
                    if (error.response) {
                        this.error.loading = error.response.data.message;
                    }
                };

            this.isLoading = true;
            UserAPI
                .getAllUsers(page - 1, 200)
                .then(handleResponse)
                .catch(handleError)
                .finally(() => this.isLoading = false);
        },

        numberUsers(users: User[]): any {
            const groups: Record<string, number> = users
                .sort((a, b) => new Date(a.creationDateTime).getTime() - new Date(b.creationDateTime).getTime())
                .reduce((group: Record<string, number>, user: User) => {
                    if (user.status === UserStatus.Validated) {
                        const date: string = user.creationDateTime.split('T')[0];
                        if (!group[date]) {
                            group[date] = 0;
                        }
                        group[date] += 1;
                    }
                    return group;
                }, {});

            const groupArrays: any[][] = [['Datum', 'Användare']];
            let totalUsers = 0;
            Object.keys(groups).forEach((date) => {
                    totalUsers += groups[date];
                    groupArrays.push([date, totalUsers]);
                });

            return groupArrays;
        },

        updatePage(page: number) {
            this.page = page;
            this.loadUsers(page);
        }
    }
});
